/**
 * Query params for the crew pick-lists on the project-services screens.
 *
 * A crew that has been retired keeps its number and its members, so it reads
 * exactly like the live crew in a picker — but it takes no new work, and a work
 * form closed out against one is refused. Offering only live crews is what
 * keeps that refusal from ever reaching a technician.
 *
 * Contains:
 * - ACTIVE_CREW_OPTIONS_PARAMS — the odl-app list params for a crew picker
 */

// odl-app grids read filters in the `filter[...]` form only; a key outside that
// form is not a declared filter and is ignored, so the bracket form is what
// makes `active` bind. `limit` lifts the response past the default 25-row page,
// which a picker has to clear to offer every crew.
export const ACTIVE_CREW_OPTIONS_PARAMS = Object.freeze({
  'filter[active]': 'true',
  sort: 'crew_number',
  limit: 500,
});
